export class CommonConstants {
  // static readonly KE_FU_URL: string = '//kf.yingxiong.com/kf2.0/select-game'
  static readonly KE_FU_URL: string = 'https://kf.yingxiong.com/kf2.0/user-center'

  static readonly IS_AREA: string = process.env.VUE_APP_AREA || 'global'

  static readonly GLOBAL_USER_PROTOCOL: string =
    process.env.VUE_APP_AREA === 'global'
      ? 'https://www.yingxiong.com/p/service_globalmall.html'
      : 'https://www.yingxiong.com/p/yxyhxy.html'

  static readonly GLOBAL_PRIVACY_PROTOCOL: string =
    process.env.VUE_APP_AREA === 'global'
      ? 'https://www.yingxiong.com/p/privacy_globalmall.html'
      : 'https://www.yingxiong.com/p/per_adu.html'

  static readonly GLOBAL_JOIN_US: string =
    process.env.VUE_APP_AREA === 'global'
      ? 'https://app.mokahr.com/social-recruitment/yingxionghr/39426#/'
      : 'https://www.yingxiong.com/p/join.html'

  static readonly IS_CN: boolean = process.env.VUE_APP_AREA === 'cn'

  static readonly IS_NOT_USE_CART_PAY = [18, -101]

  static readonly FIRST_DIALOG_SAVING_AMOUNT: number = 50
}
